const states1 = [
    "Andaman and Nicobar Islands (UT)", "Andhra Pradesh", "Arunachal Pradesh", "Assam", "Bihar", 
    "Chandigarh (UT)", "Chhattisgarh", "Dadra and Nagar Haveli and Daman and Diu (UT)", "Delhi (NCT)", 
    "Goa", "Gujarat", "Haryana", "Himachal Pradesh", "Jammu and Kashmir (UT)", "Jharkhand", 
    "Karnataka", "Kerala", "Ladakh (UT)", "Lakshadweep (UT)", "Madhya Pradesh", "Maharashtra", 
    "Manipur", "Meghalaya", "Mizoram", "Nagaland", "Odisha", "Puducherry (UT)", "Punjab", 
    "Rajasthan", "Sikkim", "Tamil Nadu", "Telangana", "Tripura", "Uttarakhand", "Uttar Pradesh", 
    "West Bengal"
];

const states2 = [
    "Andaman & Nicobar Island", "Andhra Pradesh", "Arunachal Pradesh", "Assam", "Bihar", 
    "Chandigarh", "Chhattisgarh", "Dadara & Nagar Haveli", "Delhi", 
    "Goa", "Gujarat", "Haryana", "Himachal Pradesh", "Jammu & Kashmir", "Jharkhand", 
    "Karnataka", "Kerala", "Jammu & Kashmir", "Lakshadweep", "Madhya Pradesh", "Maharashtra", 
    "Manipur", "Meghalaya", "Mizoram", "Nagaland", "Odisha", "Puducherry", "Punjab", 
    "Rajasthan", "Sikkim", "Tamil Nadu", "Telangana", "Tripura", "Uttarakhand", "Uttar Pradesh", 
    "West Bengal"
];


export const CorrectState = (value, state1 = states1, state2 = states2) => {
    // Convert comma-separated string to an array if necessary
    const parsedValues = value.includes(',') ? value.split(', ') : [value];

    // Map each parsed value to its corresponding state in state2
    const correctedValues = parsedValues.map(val => {
        const IndexValue = state1.findIndex(state => state === val);
        return IndexValue !== -1 ? state2[IndexValue] : val;
    });

    // Join the corrected values back into a single string
    return correctedValues.join(', ');
};

  